'use client';

import { ContractWrapper } from '@/components/accountSettings/termsAndCondition/TermsAndConditions';
import TermsPreview from './TermsPreview';
import { color, spacing } from '@/theme/tokens';
import { Box, styled, Typography } from '@mui/material';
import { useTranslations } from 'next-intl';
import HTMLDownloadWrapper from '@/components/common/HTMLDownloadWrapper';
import { termsOfUseHtml } from './html/terms-of-use-content';

const termsStyles = `
    /* Base styles for custom counter lists rendered from HTML content */
    ul {
        list-style: none !important;
    }

    ul > li {
        position: relative !important;
    }


    /* ── Decimal list: X.Y (section sub-items, uses --prefix CSS var) ── */
    ul.decimal-list {
        counter-reset: decimal-item;
        padding-left: ${spacing[40]};
    }

    ul.wide-decimal-list {
        padding-left: ${spacing[40]};
    }

    ul.decimal-list > li {
        counter-increment: decimal-item;
    }

    ul.decimal-list > li::before {
        content: var(--prefix) '.' counter(decimal-item);
        position: absolute;
        left: -${spacing[40]};
    }

    ul.wide-decimal-list > li::before {
        content: var(--prefix) '.' counter(decimal-item);
        position: absolute;
        left: -${spacing[40]} !important;
    }

    /* ── Sub-decimal list: X.Y.Z (nested sub-items, uses --prefix CSS var) ── */
    ul.sub-decimal-list {
        counter-reset: sub-decimal-item;
        padding-left: ${spacing[40]};
    }

    ul.sub-decimal-list > li {
        counter-increment: sub-decimal-item;
    }

    ul.sub-decimal-list > li::before {
        content: var(--prefix) '.' counter(sub-decimal-item);
        position: absolute;
        left: -${spacing[40]};
    }
`;

const ContainerStyled = styled(Box)`
    ${termsStyles}
`;

export default function Terms() {
    const t = useTranslations('CommonTermsAndConditions');

    const printableTermsConditionsHtml = `<h1>${t('terms.heading')}</h1>` + termsOfUseHtml;

    return (
        <ContainerStyled>
            <ContractWrapper>
                <Typography
                    variant="heading2bold"
                    color={color.gray[80]}
                    style={{ marginBottom: spacing[32] }}
                    component="div"
                >
                    {t('terms.heading')}
                </Typography>
                {/* Compile-time HTML constant from ./html/*.ts — no runtime or user input reaches this sink. */}
                {/* react-doctor-disable-next-line react-doctor/dangerous-html-sink */}
                <TermsPreview dangerouslySetInnerHTML={{ __html: termsOfUseHtml }} />
            </ContractWrapper>

            <HTMLDownloadWrapper
                filename="W8ShippingTermsOfUse"
                downloadButtonText={t('terms.downloadButtonText')}
                downloadText={t('downloadText')}
                htmlContent={printableTermsConditionsHtml}
                customStyles={termsStyles}
            />
        </ContainerStyled>
    );
}
